import React from 'react';

import { Button, HorizontalContainer, VerticalContainer } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { VideoCallButton } from './VideoCallButton';

type EarlyJoinWarningViewProps = {
    onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onCancel: () => void;
};

export const EarlyJoinWarningView = ({
    onConfirm,
    onCancel,
}: EarlyJoinWarningViewProps) => {
    return (
        <VerticalContainer spacing="lg">
            <p>{R.EarlyJoinWarningDescription}</p>
            <HorizontalContainer className="justify-end">
                <Button variant="secondary" onClick={onCancel}>
                    {R.NoCancel}
                </Button>
                <VideoCallButton onClick={onConfirm} disabled={false} />
            </HorizontalContainer>
        </VerticalContainer>
    );
};
